import React, { useContext, useEffect } from 'react';
import { withNativeProps } from '../../utils/native-props';
import { IndexBarContext } from './context';
var classPrefix = "adm-index-bar-anchor";
export var Panel = function Panel(props) {
  var _useContext = useContext(IndexBarContext),
      setIndexes = _useContext.setIndexes;

  useEffect(function () {
    setIndexes(function (val) {
      return val.concat([props.index]);
    });
    return function () {
      setIndexes(function (val) {
        return val.filter(function (x) {
          return x !== props.index;
        });
      });
    };
  }, [props.index]);
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    "data-index": props.index,
    className: classPrefix
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-title"
  }, props.title || props.index), props.children));
};